/* EKNO predictive search — Shopify Predictive Search API rendered through the predictive-search section. */
(function () {
  'use strict';
  const EKNO = window.EKNO;

  class EknoPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('.predictive-search__results');
      this.status = this.querySelector('.predictive-search__status');
      this.clearBtn = this.querySelector('[data-search-clear]');
      this.enabled = this.dataset.enabled !== 'false';
      if (!this.input || !this.results) return;
      this.input.addEventListener('input', EKNO.utils.debounce(() => this.onInput(), 250));
      this.input.addEventListener('keydown', (e) => this.onKey(e));
      this.clearBtn?.addEventListener('click', () => { this.input.value = ''; this.clear(); this.input.focus(); });
      this.results.addEventListener('mousedown', (e) => e.preventDefault());
      this.abort = null;
    }
    onInput() {
      const term = this.input.value.trim();
      if (this.clearBtn) this.clearBtn.hidden = term.length === 0;
      if (!this.enabled) return;
      if (term.length < 2) { this.clear(); return; }
      this.search(term);
    }
    async search(term) {
      if (this.abort) this.abort.abort();
      this.abort = new AbortController();
      this.results.setAttribute('aria-busy', 'true');
      const resources = ['product'];
      try {
        const url = `${EKNO.routes.predictiveSearch}?q=${encodeURIComponent(term)}&resources[type]=product,collection,page,query&resources[limit]=6&resources[limit_scope]=each&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag&section_id=predictive-search`;
        const res = await fetch(url, { signal: this.abort.signal });
        if (!res.ok) throw new Error(res.statusText);
        const html = await res.text();
        const section = EKNO.utils.sectionHTML(html, '#shopify-section-predictive-search');
        this.results.innerHTML = section ? section.innerHTML : '';
        this.input.setAttribute('aria-expanded', 'true');
        const count = this.results.querySelectorAll('[role="option"]').length;
        if (this.status) this.status.textContent = count ? `${count} ${EKNO.strings.loading ? '' : ''}`.trim() : '';
        this.selected = -1;
      } catch (e) {
        if (e.name !== 'AbortError') this.results.innerHTML = '';
      } finally { this.results.removeAttribute('aria-busy'); }
    }
    clear() { this.results.innerHTML = ''; this.input.setAttribute('aria-expanded', 'false'); this.selected = -1; }
    onKey(e) {
      const options = Array.from(this.results.querySelectorAll('[role="option"]'));
      if (e.key === 'Escape') { this.clear(); return; }
      if (!options.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        this.selected = e.key === 'ArrowDown' ? Math.min(options.length - 1, (this.selected ?? -1) + 1) : Math.max(0, (this.selected ?? 0) - 1);
        options.forEach((o, i) => o.setAttribute('aria-selected', i === this.selected ? 'true' : 'false'));
        this.input.setAttribute('aria-activedescendant', options[this.selected].id);
        options[this.selected].scrollIntoView({ block: 'nearest' });
      }
      if (e.key === 'Enter' && this.selected > -1) { e.preventDefault(); options[this.selected].click(); }
    }
  }
  customElements.define('ekno-predictive-search', EknoPredictiveSearch);
})();
